import type { OptIn } from '../services/SecurityService/types';
import type { PartnerSetupStep } from '../../types';

// based on partner optins determine what steps
// the use needs to take to complete setup
export const getSetupSteps = (optIns: OptIn[]): Record<PartnerSetupStep, boolean> => {
  const requiredOptins = optIns.reduce((enabledOptins: any, val) => {
    enabledOptins[val.optInId] = val.active;
    return enabledOptins;
  }, {});
  const setUpSteps: Record<PartnerSetupStep, boolean> = {
    REGISTER: true,
    INVITE: true,
    DATA_UPLOAD: true,
    VOLUME_ESTIMATES: true,
    NETWORK_CONFIG: true,
    REPORTING_CONFIG: requiredOptins['reporting-opt-in'],
    CARRIER_ACCOUNT: requiredOptins['carrier-selection-opt-in'],
    LABEL_CONFIGURATION: requiredOptins['shipping-label-retrieval-opt-in'],
    PACKAGE_CONFIGURATION: requiredOptins['package-sizing-opt-in'],
  };
  return setUpSteps;
};
